module.exports = __webpack_public_path__ + "img/god-ape-good.2bb65d07.png";